/**
 * M DA LINHA NA BASE VIVO (Douglas 26/09/2026) — uma conta só, nas duas abas.
 * O M do arquivo é o M INICIAL (da carga); o M de AGORA anda +1 por mês desde
 * a carga. Sem multa: não fidelizada, M 999, ou M de agora ≥ 24. Na conta,
 * basta UMA linha sem multa para o CNPJ contar como sem multa.
 */
export interface LinhaM { m?: number | null; fidelizado?: string | null; dt_carga?: string | null }

export function mesesDesdeCarga(dtCarga?: string | null): number {
  if (!dtCarga) return 0;
  const d = new Date(dtCarga);
  if (isNaN(d.getTime())) return 0;
  const hoje = new Date();
  const meses = (hoje.getFullYear() - d.getFullYear()) * 12 + (hoje.getMonth() - d.getMonth());
  return meses > 0 ? meses : 0;
}

export function mAgoraLinha(l: LinhaM): number | null {
  if (l?.m == null) return null;
  if (l.m === 999) return 24;
  return l.m + mesesDesdeCarga(l.dt_carga);
}

export function linhaSemMulta(l: LinhaM): boolean {
  return l.m === 999 || l.fidelizado === 'Não Fidelizado' || (mAgoraLinha(l) ?? 0) >= 24;
}

export function mDaConta(linhas: LinhaM[] | null | undefined) {
  const lista = linhas ?? [];
  const iniciais = lista.map((l) => l.m).filter((m): m is number => m != null && m !== 999);
  const agoras = lista.map(mAgoraLinha).filter((m): m is number => m != null);
  const semMulta = lista.filter(linhaSemMulta).length;
  return {
    mInicial: iniciais.length ? Math.max(...iniciais) : 0,
    mAgora: agoras.length ? Math.max(...agoras) : 0,
    linhasSemMulta: semMulta,
    semMulta: semMulta > 0,
  };
}
